// Response shapes for the conductor scheduling endpoints, mirroring
// merge-backend's AccountSyncStatus / OrganizationSyncSpeed app models.

export interface AccountSyncStatus {
  id: string;
  organization_id: string;
  linked_account_id: string;
  /** Resolved from the local DB by the API layer; conductor only stores the id. */
  linked_account_name: string | null;
  tenant_id: string | null;
  category: string | null;
  /** The organization's backend-resolved entitlement, inherited on read. Read-only. */
  speed: string;
  /** The account-level admin override, null when unset. */
  speed_override: string | null;
  /** The org-level override covering this account, null when unset. Read-only here. */
  organization_speed_override: string | null;
  /**
   * Resolved by conductor as account override > org override > entitlement.
   * Rendered as given, never recomputed in the UI.
   */
  effective_speed: string;
  /** Free-text mirror of the backend linked account status. Read-only. */
  status: string;
  conductor_scheduled: boolean;
  modified_at: string | null;
}

// One durable row per organization carrying both writers: `speed` is the
// entitlement merge-backend resolves from billing, `speed_override` is the admin
// lever. The override covers every linked account in the org without one of its
// own, including accounts linked later.
export interface OrganizationSyncSpeed {
  id: string;
  organization_id: string;
  /** Backend-resolved entitlement, null when backend has not written one yet. */
  speed: string | null;
  /** The admin override, null when unset. */
  speed_override: string | null;
  /** speed_override, else speed. Always populated. */
  effective_speed: string;
  modified_at: string | null;
}

export const SPEED_OPTIONS = [
  { value: "ACCOUNT_SYNC_SPEED_FAST", label: "Fast" },
  { value: "ACCOUNT_SYNC_SPEED_DAILY", label: "Daily" },
  { value: "ACCOUNT_SYNC_SPEED_NONE", label: "None" },
];

export const speedLabel = (speed: string): string =>
  SPEED_OPTIONS.find((option) => option.value === speed)?.label ??
  speed.replace(/^ACCOUNT_SYNC_SPEED_/, "");
